<template>
    <v-dialog v-model="dialog" :width="width">
        <v-card flat>
            <v-card-title class="pl-3">Mails</v-card-title>
            <v-divider class="mb-0"></v-divider>
            <div v-if="loading" class="mx-0 px-0 py-4" align="center">
                <v-progress-circular :width="5" :size="40" color="green" indeterminate></v-progress-circular>
                <span>loading...</span>
            </div>
            <mail_table :mails="mails" v-if="!loading"/>
            <v-divider class="mb-0"></v-divider>
            <v-card-actions class="mt-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>        
    </v-dialog>
</template>
  
<script>

    import mail_table from '@/components/ui/tables/mails.vue';

    export default {    
        props:{
            width:{
                type: String,
                default: '1200px'
            }
        },        
        components: {
            mail_table
        },
        data() {
            return {
                dialog: false,
                loading: true,
                mails: [],
            }
        },
        methods: {
            closeDialog(){
                this.dialog = false;
            },
            open(heho_encrid) {
                this.dialog = true;
                this.loading = true;
                this.$axios.post("ares/json/ares/heho/getHehoEmails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHehoEmails",
                    },
                    getHehoEmails: {
                        heho_encrid: heho_encrid,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.mails = res.data.getHehoEmails.mail;
                        this.loading = false;
                    }
                })
            },
        },
    };
</script>
  
  